import { MenuItem } from '@/shared/components/nav/MenuItem';
import { posthogCapture } from '@/shared/vendor/posthog';

const ReportsMenuItem = () => (
  <MenuItem
    data-testid="top-nav-reports"
    onClick={() => posthogCapture('top_nav.reports')}
    hideLabel="tablet"
    icon="reporting"
    label="Reports"
    to="/reporting"
  />
);

export default ReportsMenuItem;
